import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { getRow, getRows } from "../requests/games"
import { API_Data_Get_Row_Response, API_Data_Get_Rows_Response } from "@/interfaces/api/rows/api_response_types"

type UseRowParams = {
  id: string,
  locale: string
  profileId: string | null | undefined
}

type RowQueryKey = ['row', string, string, string | null | undefined]

type RowOptions = Omit<
  UseQueryOptions<API_Data_Get_Row_Response, API_Error, API_Data_Get_Row_Response, RowQueryKey>,
  'queryKey' | 'queryFn'
>

export const useRow = ({ id, locale, profileId }: UseRowParams, options?: RowOptions) => 
  useQuery<API_Data_Get_Row_Response, API_Error, API_Data_Get_Row_Response, RowQueryKey>({
    queryKey: ['row', id, locale, profileId],
    retry: false,
    queryFn: () => getRow(id, locale, profileId),
    ...options
  })